/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CompanyCreateInput = {
    readonly name: string;
    readonly vatNumber: string;
    readonly registrationNumber: string;
    readonly contactNumber: string;
    readonly emailAddress: string;
    readonly licenseType?: string | null;
    readonly licenseNumber?: string | null;
    readonly licenseExpiry?: any | null;
    readonly secondaryLicenseType?: string | null;
    readonly secondaryLicenseNumber?: string | null;
    readonly secondaryLicenseExpiry?: any | null;
    readonly tradeLimit: number;
    readonly sharepointIdentifier?: string | null;
    readonly clientMutationId?: string | null;
};
export type CompanyCreateMutation_MutationVariables = {
    readonly input: CompanyCreateInput;
};
export type CompanyCreateMutation_MutationResponse = {
    readonly companyCreate: ({
        readonly clientMutationId: string | null;
    }) | null;
};
export type CompanyCreateMutation_Mutation = {
    readonly response: CompanyCreateMutation_MutationResponse;
    readonly variables: CompanyCreateMutation_MutationVariables;
};



/*
mutation CompanyCreateMutation_Mutation(
  $input: CompanyCreateInput!
) {
  companyCreate(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CompanyCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "companyCreate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CompanyCreateInput!"
      }
    ],
    "concreteType": "CompanyCreatePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "CompanyCreateMutation_Mutation",
  "id": null,
  "text": "mutation CompanyCreateMutation_Mutation(\n  $input: CompanyCreateInput!\n) {\n  companyCreate(input: $input) {\n    clientMutationId\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CompanyCreateMutation_Mutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "CompanyCreateMutation_Mutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
(node as any).hash = '7f84097549e97c1ef832eccef2fdfcd5';
export default node;
